import { Button, Typography } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const CustomButton = ({
  onClick,
  size,
  height,
  width,
  variant = "contained",
  title,
  submit,
  autoFocus,
  fullWidth,
  underline,
  fontSize,
  disabled,
  color,
  textColor,
  href,
  startIcon,
  endIcon
}) => {
  const { bt } = useBizTypeTranslation();

  return (
    <Button
      href={href}
      target={href ? "_blank" : null}
      sx={{
        width: width,
        height: height,
        minHeight: height,
        textTransform: "none",
        bgcolor: variant === "contained" ? color ?? "primary" : "transparent",
        border: variant === "text" ? 0 : 1,
        "&:hover": {
          bgcolor: variant === "contained" ? color ?? "primary" : "transparent",
          border: variant === "text" ? 0 : 1,
          opacity: 0.9,
        },
      }}
      disabled={disabled ? true : false}
      variant={variant ?? "contained"}
      size={size ? size : "small"}
      onClick={onClick ? onClick : () => { }}
      type={submit ? "submit" : "button"}
      autoFocus={autoFocus ? true : false}
      fullWidth={fullWidth ? true : false}
      startIcon={startIcon ?? null}
      endIcon={endIcon ?? null}
    >
      <Typography
        fontSize={fontSize ?? 16}
        noWrap
        color={textColor && !disabled
          ? textColor
          : variant === "contained"
            ? "bgPage.main"
            : "primary.main"
        }
        sx={{
          textDecoration: underline ? "underline" : "",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",

        }}
      >
        {bt(title)}
      </Typography>
    </Button>
  );
};
export default CustomButton;
